import React from 'react';
import { Link } from 'react-router-dom';
import {
  Card, CardBody, CardImg, CardTitle,
} from 'reactstrap';
import PropTypes from 'prop-types';

function formatAsURLPart(target) {
  let result = target.toLowerCase();
  result = result.replace(/ /g, '_');

 return result;
}

const IntegrationCard = function ({ integration }) {
  return (
    <Card className="m-5" style={{ width: '10rem', height: '7rem' }}>
      <Link
        to={`integrations/${formatAsURLPart(integration.name)}`}
      >
        <CardImg
          className="bg-white px-4 py-2"
          alt={integration.alt}
          src={integration.src}
          top
        />
      </Link>
      <CardBody>
        <CardTitle tag="h5" className="bold-text text-center">
          {integration.name}
        </CardTitle>
      </CardBody>
    </Card>
  );
};

IntegrationCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  integration: PropTypes.object.isRequired,
};

export default IntegrationCard;
